import EditAndDeleteButton from '../../../components/button/EditAndDeleteButton';
import DisabledCheckbox from '../../../components/inputs/DisabledCheckbox';
import PasswordCell from '../../../components/text/Password';
import { EmployeesArray } from '../../../types/employee/EmployeeGetResponse';

interface RenderEmployeeRowProps {
  item: EmployeesArray;
  editingId: number | null;
  onEditButtonClick: (item: EmployeesArray) => void;
  onDeleteButtonClick: (item: EmployeesArray) => void;
}

const RenderEmployeeRow = ({
  item,
  editingId,
  onEditButtonClick,
  onDeleteButtonClick,
}: RenderEmployeeRowProps) => {
  return (
    <>
      <td>{item.employeeCode}</td>
      <td>{item.name}</td>
      <td>
        <PasswordCell password={item.password} />
      </td>
      <td>
        <DisabledCheckbox checked={item.isDairen} />
      </td>
      <td>
        <DisabledCheckbox checked={item.isAdmin} />
      </td>
      <td className="text-center" style={{ verticalAlign: 'middle' }}>
        <EditAndDeleteButton
          onEdit={() => onEditButtonClick(item)}
          onDelete={() => onDeleteButtonClick(item)}
          editingRowIndex={editingId}
        />
      </td>
    </>
  );
};

export default RenderEmployeeRow;
